import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/authentication/auth.service';
import { Usuario } from 'src/app/authentication/interfaces/interfaces';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service';
import { DataTableDirective } from 'angular-datatables';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'app-analisis-cefalometrico',
    templateUrl: './analisis-cefalometrico.component.html',
    styleUrls: ['./analisis-cefalometrico.component.scss'],
    standalone: false
})
export class AnalisisCefalometricoComponent implements OnInit {

  ordenes: any = [];
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  
  public pagina;
  public busqueda;
  public limite;
  public spinnerBoolean: boolean = false;
  public estadoDT: string = 'pendiente';
  public perfil: string = '';
  public myTable: boolean = false;
  max =  new Date().getFullYear();
  //Retso el año - 10 para mostrar en el select de años
  min = this.max - 4;
  aniosFiltro:any = [];
  public anioSeleccionado = this.max;
  public pageNumber: number;
  public size: number;
  public totalElements: number;
  private _usuario!: Usuario;
  public idSucursal!: string;
  public perfilUsuario!: string;
  public nombreSucursal: string = "";
  public idUsuario!:string;
  
  constructor(
    private ordenesService: OrdenesService,
    private authService: AuthService,
    private toastr: ToastrService,
    private ngZone: NgZone,
    public router: Router) {
    this.pageNumber = 0;
    this.size = 10;
    this.totalElements = 0;
    this._usuario = authService.loginUsuario;
   }

  ngOnInit(): void {
    this.idSucursal = this._usuario.sucursal!;
    this.nombreSucursal = this._usuario.nombreSucursal!;
    this.perfil = this._usuario.perfil!;
    this.idUsuario = this._usuario.idUsuario!;
    this.dtPendienteAnalisis();
  }

  dtPendienteAnalisis() {
    // this.reload();
    
    this.estadoDT = 'pendiente';
    const that = this;
    that.ordenes = [];
    this.myTable = false;

    let lastPage = 0;
    let lastSearchText = "";
    this.dtOptions = {
      language: LanguageApp.spanish_datatables,
      pagingType: 'full_numbers',
      pageLength: 10,
      displayStart: lastPage, // Last Selected Page
      search: { search: lastSearchText }, // Last Searched Text
      serverSide: true,
      // processing: true,
      responsive: false,
      retrieve: true,
      orderClasses: false,
      processing: true,
      deferRender: true,
      searchDelay: 1500,
      ajax: (dataTablesParameters: any, callback) => {

        this.pagina = dataTablesParameters.start;
        this.busqueda = dataTablesParameters.search.value;
        this.limite = dataTablesParameters.length;

        this.ngZone.run(() => {
          this.ordenes = [];
        });

        this.ordenesService.datatableOrdenesPendienteAnalisis(
          this.estadoDT,
          this.perfil,
          this.nombreSucursal,
          this.limite,
          this.pagina,
          this.busqueda,
          this.anioSeleccionado
        ).subscribe(resp => {

          this.ngZone.run(() => {
            this.ordenes = resp.data;
            this.spinnerBoolean = false;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });

        })

      }
    }
  }

  subirImagenesAnalisis(idOrden) {
    this.router.navigate(['/sistema/subir-imagenes-analisis', this.makeid(100) + idOrden + this.makeid(100)]);
  }

  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJ12345679KLMNOPQRST08765454UVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  imprimirOrden(orden, doctor, telefonoDoctor) {
    const pdfWindow = window.open('', '_blank');
    this.ordenesService.generarOrdenTransferencia(
      localStorage.getItem('token'),
      orden,
      doctor,
      telefonoDoctor
    ).subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        if (pdfWindow) {
          pdfWindow.location.href = url;
        } else {
          window.open(url, '_blank');
        }
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
      },
      error: (error) => {
        pdfWindow?.close();
        this.toastr.error(
          error?.error?.message || 'No fue posible generar la orden',
          'Atención'
        );
      }
    });
  }

  reload() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload();
    });
  }

}

export class LanguageApp {
  public static spanish_datatables = {
    processing: "Procesando...",
    search: "Buscar:",
    lengthMenu: "Mostrar _MENU_ registros",
    info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
    infoEmpty: "Mostrando ningún elemento.",
    infoFiltered: "(filtrado _MAX_ elementos total)",
    infoPostFix: "",
    loadingRecords: "Cargando registros...",
    zeroRecords: "No se encontraron registros",
    emptyTable: "No hay datos disponibles en la tabla",
    paginate: {
      first: "Primero",
      previous: "Ant",
      next: "Sig",
      last: "Último"
    },
    aria: {
      sortAscending: ": Activar para ordenar la tabla en orden ascendente",
      sortDescending: ": Activar para ordenar la tabla en orden descendente"
    }
  }

}
